module.exports = __webpack_public_path__ + "media/images/mobile-view-1152-b1fc498c1722abd3a38505e815aaf3f7.svg";